import { useState, useEffect } from "react";
import googlePlayIcon from "../../../assets/images/google-play.png";
import appStoreIcon from "../../../assets/svgs/purpleappleicon.svg";
// import mail from "../../../assets/svgs/mail.svg";
import linkdin from "../../../assets/svgs/linkdin.svg";
import ig from "../../../assets/svgs/ig.svg";
import tiktok from "../../../assets/images/tik-tok.png"
// import phone from "../../../assets/svgs/phone.svg";
import footerBg from "../../../assets/images/Softlight.png";
import xIcon from "../../../assets/svgs/twitter1.png"
import youtube from "../../../assets/svgs/youtube.png"
import { Link, useNavigate, useLocation } from "react-router-dom";

const Footer: React.FC = () => {
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (route: string) => {
    navigate(route); 
    window.scrollTo(0, 0); 
  };

  const scrollToSection = (sectionId: string) => {
    if (location.pathname !== "/") {
      navigate("/", { 
        state: { scrollTo: sectionId } 
      });
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };

  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        setTimeout(() => { 
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 100);
      }
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, navigate, location.pathname]);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 640); 
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <footer
      className={`max-w-[98%] mx-auto ${
        isSmallScreen ? "py-14 px-8" : "py-14 sm:py-28 px-6 sm:px-12 lg:px-24"
      } mt-36 mb-4 bg-purple-800 text-white rounded-2xl relative`}
      style={{
        backgroundImage: `url(${footerBg})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div
        className={`flex ${
          isSmallScreen ? "flex-col gap-14" : "sm:flex-row gap-14 sm:gap-28"
        } justify-start items-start`}
      >
        <div className="text-left max-w-lg sm:flex-shrink-0">
          <div className="flex items-center mb-4">
            <div className="flex-shrink-0">
              <img src="/vite.svg" alt="Beats Fussion Logo" className="w-16 h-16" />
            </div>
            <Link to="/" onClick={() => handleNavigation("/")}><h3 className="ml-3 text-xl font-bold">Beat Fussion</h3></Link>
          </div>
          <p className="text-xs sm:text-sm mb-4">
            Discover, compete and connect with Nigeria's premier dance competition. Elevate your dance journey.
          </p>
          <div className="flex space-x-3">
            <button className="flex items-center justify-center px-3 py-2 bg-white text-purple-800 rounded-md shadow-md hover:bg-gray-100">
              <img src={appStoreIcon} alt="App Store" className="w-4 h-4 sm:w-6 sm:h-6 mr-2" />
              <span className="text-xs sm:text-xs text-left font-medium">
                Download on the <br /> <span className="text-sm sm:text-lg">App Store</span>
              </span>
            </button>
            <Link to="https://play.google.com/store/apps/details?id=com.techwings.beatsfussion" target="_blank" className="flex items-center justify-center px-3 py-2 bg-white text-purple-800 rounded-md shadow-md hover:bg-gray-100">
              <img src={googlePlayIcon} alt="Google Play" className="w-4 h-4 sm:w-6 sm:h-6 mr-2" />
              <span className="text-xs sm:text-xs text-left font-medium">
                Get it on <br /> <span className="text-sm sm:text-lg">Google Play</span>
              </span>
            </Link>
          </div>
        </div>

        <div className="text-left max-w-lg sm:flex-shrink-0">
          <h4 className="text-base sm:text-lg font-bold mb-2 sm:mb-4">Beatfussion</h4>
          <ul className="space-y-1 sm:space-y-2">
            <li>
              <button 
                onClick={() => scrollToSection('benefits')}
                className="text-xs sm:text-sm hover:text-gray-300 cursor-pointer"
              >
                Benefits
              </button>
            </li>
            <li>
              <button 
                onClick={() => scrollToSection('features')}
                className="text-xs sm:text-sm hover:text-gray-300 cursor-pointer"
              >
                Features
              </button>
            </li>
            <li>
              <button 
                onClick={() => scrollToSection('pricing')}
                className="text-xs sm:text-sm hover:text-gray-300 cursor-pointer"
              >
                Pricing
              </button>
            </li>
            <li>
              <Link to="/support" onClick={() => handleNavigation("/support")} className="text-xs sm:text-sm hover:text-gray-300">
                Support
              </Link>
            </li>
          </ul>
        </div>

        <div className="text-left max-w-lg sm:flex-shrink-0">
          <h4 className="text-base sm:text-lg font-bold mb-2 sm:mb-4">Stay in touch</h4>
          <div className="flex space-x-3">
            {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <img src={mail} alt="Facebook" className="w-5 h-5 hover:opacity-75" />
            </a> */}
            <a href="https://x.com/beatsfussion/status/1936022208876626348?t=u3Z4kThS1lMnZ8bZUEM7BQ&s=19" target="_blank" rel="noopener noreferrer">
              <img src={xIcon} alt="phone" className="w-5 h-5 hover:opacity-75" />
            </a>
            <a href="https://www.instagram.com/beatsfussion/?igsh=bDczbWZ2enNia3kz&utm_source=qr#" target="_blank" rel="noopener noreferrer">
              <img src={ig} alt="Instagram" className="w-5 h-5 hover:opacity-75" />
            </a>
            <a href="https://www.tiktok.com/@beatsfussion" target="_blank" rel="noopener noreferrer">
              <img src={tiktok} alt="tiktok" className="w-5 h-5 hover:opacity-75" />
            </a>
            <a href="https://www.linkedin.com/company/tachwingds-global/" target="_blank" rel="noopener noreferrer">
              <img src={linkdin} alt="LinkedIn" className="w-5 h-5 hover:opacity-75" />
            </a>
            <a href="https://www.youtube.com/@beatsfussionentertainment" target="_blank" rel="noopener noreferrer">
              <img src={youtube} alt="Youtube" className="w-5 h-5 hover:opacity-75" />
            </a>
          </div>
        </div>
      </div>

      <div
        className={`mt-8 pt-4 flex ${
          isSmallScreen ? "flex-col items-center space-y-4" : "justify-between items-center"
        }`}
      >
        <p className="text-xs sm:text-sm">Beatfussion © 2026 All rights reserved</p>
        <div className={`flex ${isSmallScreen ? "space-x-3" : "space-x-6 sm:space-x-4"}`}>
          <a target="_blank" rel="noopener noreferrer"
            href="https://juicy-cress-15f.notion.site/Beats-Fussion-from-TWG-Data-Protection-and-Privacy-Policy-19d501e548cb801caeb7eac54327640e" className="text-xs sm:text-sm hover:text-gray-300">
            Privacy Policy
          </a>
          <a target="_blank" rel="noopener noreferrer"
            href="https://juicy-cress-15f.notion.site/Beats-Fussion-from-TWG-Terms-Of-Use-And-Service-19d501e548cb80d3b03de88e63e94441" className="text-xs sm:text-sm hover:text-gray-300">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;